// İSG uzmanı portalı — sekme paneli giriş satırı (owner review B1 item 6, 2026-09-28).
//
// Detay sayfalarının Tabs + Tile ikilisi `carbon:p-0` ile TAM sıfır dolgu render eder
// (`PermitDetailPage.tsx`/`ContractorDetailPage.tsx`'in "Tabs + Tile ARASINDA boşluk YOK"
// notu) — bu, tablo/araç çubuğu olan sekmelerde DOĞRU (Carbon "toolbar flush, table
// full-bleed"), ama yalnız bir açıklama cümlesiyle (± bir aksiyon düğmesi) başlayan sekmelerde
// o cümle sekme listesinin ALT KENARINA yapışık render ediyordu — üç ayrı kopyada üç ayrı
// biçimde (`PermitActivityPanel`/`PermitControlChecklistPanel`/`PermitDocumentRequestsPanel`
// yalnız `<p className="px-1 text-xs text-muted carbon:pl-4">`; `PersonnelPanel`/
// `DocumentsPanel`/`SitesPanel` yalnız `<p className="text-sm text-muted">` + bitişik `Button`,
// üstelik Carbon'da 14px'te KALIYORDU — `PermitProtectiveEquipmentPanel`'in araç çubuğundaki
// AYNI cümle `carbon:text-xs`e düşer). Kök neden köşe köşe değil, kalıbın kendisiydi — bu
// yüzden TEK bileşen: her ikisi de bu tek şekle döner (aksiyon YOKSA `action` verilmez, tek
// çocuk `justify-between`de sola yaslanır).
//
// `pt-4` (spacing-05, 16px) — sekme listesiyle bu satır arasındaki ZORUNLU boşluk (owner
// kararı); `px-1`/`carbon:px-4` yatay hizalama `TableToolbar`'ın `carbon:pl-4`'üyle AYNI
// (Tile'ın kendi 16px dolgusu `carbon:p-0` ile sıfırlandığından, hizalamayı içerik taşımak
// zorunda). Metin `text-xs` (Carbon caption boyutu, KKD'nin araç çubuğundaki
// `carbon:text-xs`ile AYNI) — üç kopyanın zaten doğru olan boyutu, üç "aksiyon eşlikli"
// kopyanın (Personnel/Documents/Sites) `text-sm`'i buraya göç ederken düzeltildi.

import type { ReactNode } from 'react';

export function TabPanelIntro({
  children,
  action,
}: {
  children: ReactNode;
  /** Sağ taraf aksiyonu (ör. "Davet Et"/"Yeni") — verilmezse hiç render edilmez. */
  action?: ReactNode;
}) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 px-1 pt-4 carbon:px-4">
      <p className="min-w-0 flex-1 basis-64 text-xs text-muted">{children}</p>
      {action}
    </div>
  );
}
